import api from './api'


const getRedemptions = (userId: string) => api.request(`/api/users/${userId}/redemptions`)
const getPoints = (userId: string) => api.request(`/api/users/${userId}/points`)
const updateStatus = (id: string, status: string) => {
  const url = status === 'rejected' ? `/api/cashbacks/${id}/reject` : `/api/cashbacks/${id}/confirm`
  return api.request(url, 'PATCH', { status });
}
const getAllByStatus = (status: string) => api.request(`/api/cashbacks?status=${status}`)
const redeem = (userId: string, data: any) => api.request(`/api/users/${userId}/redeem`, 'POST', data)


export default {
    getAllByStatus,
    getPoints,
    updateStatus,
    getRedemptions,
    redeem,
}